/**
 * Configuración de tipos de movimientos de inventario Dfontana
 * Basado en template_used_discount.csv
 */

export interface MovementTypeConfig {
  code: string;
  endpoint: 'insert' | 'insertSkipCentralization' | null;
  gloss: string;
  originStowageId?: string;
  destinationStowageId?: string;
  reasonId?: string;
  providerId?: string;
  requiresCentralization: boolean;
}

export const DFONTANA_MOVEMENT_TYPES: { [key: string]: MovementTypeConfig } = {
  'CIFALCORR': {
    code: 'CIFALCORR',
    endpoint: 'insert',
    gloss: 'la acción cuando se utiliza un material de bodega móvil o de una factura a Mantencion correctiva Falabella',
    originStowageId: 'BM 22',
    destinationStowageId: '',
    reasonId: 'COMPRA',
    requiresCentralization: true
  },
  'AJUSTENTRADA': {
    code: 'AJUSTENTRADA',
    endpoint: 'insertSkipCentralization',
    gloss: 'la acción de ingresar un material físico a bodega central o móvil',
    originStowageId: '',
    destinationStowageId: 'BM 22',
    reasonId: 'ENTRADA',
    requiresCentralization: false
  },
  'AJUSTESALIDA': {
    code: 'AJUSTESALIDA',
    endpoint: 'insertSkipCentralization',
    gloss: 'la acción de ingresar un material físico a bodega central o móvil',
    originStowageId: 'BM 22',
    destinationStowageId: '',
    reasonId: 'SALIDA',
    requiresCentralization: false
  },
  'CI': {
    code: 'CI',
    endpoint: 'insert',
    gloss: 'la acción de rebajar un material de bodega netamente cuando se usa en nuestra instalación o venta de este a personal',
    originStowageId: 'BM 22',
    destinationStowageId: '',
    reasonId: 'VENTA',
    requiresCentralization: true
  },
  'CIC': {
    code: 'CIC',
    endpoint: 'insert',
    gloss: 'la acción de utilizar un repuesto con nuestros clientes siendo un trabajo correctivo desde bodegas o facturas',
    originStowageId: 'BM 22',
    destinationStowageId: '',
    reasonId: 'VENTA',
    requiresCentralization: true
  },
  'CICYE': {
    code: 'CICYE',
    endpoint: 'insert',
    gloss: 'la acción de utilizar un repuesto con nuestros clientes siendo un trabajo correctivo desde bodegas o facturas',
    originStowageId: 'BM 22',
    destinationStowageId: '',
    reasonId: 'VENTA',
    requiresCentralization: true
  },
  'CIFALPREV': {
    code: 'CIFALPREV',
    endpoint: 'insert',
    gloss: 'la acción de utilizar un repuesto con nuestros clientes siendo un trabajo correctivo desde bodegas o facturas',
    originStowageId: 'BM 22',
    destinationStowageId: '',
    reasonId: 'VENTA',
    requiresCentralization: true
  },
  'CIFALREAC': {
    code: 'CIFALREAC',
    endpoint: 'insert',
    gloss: 'la acción de utilizar un repuesto con nuestros clientes siendo un trabajo correctivo desde bodegas o facturas',
    originStowageId: 'BM 22',
    destinationStowageId: '',
    reasonId: 'VENTA',
    requiresCentralization: true
  },
  'CII': {
    code: 'CII',
    endpoint: 'insert',
    gloss: 'la acción de utilizar un repuesto con nuestros clientes siendo un trabajo correctivo desde bodegas o facturas',
    originStowageId: 'BM 22',
    destinationStowageId: '',
    reasonId: 'VENTA',
    requiresCentralization: true
  },
  'CIL': {
    code: 'CIL',
    endpoint: 'insert',
    gloss: 'la acción de utilizar un repuesto con nuestros clientes siendo un trabajo correctivo desde bodegas o facturas',
    originStowageId: 'BM 22',
    destinationStowageId: '',
    reasonId: 'VENTA',
    requiresCentralization: true
  },
  'CIP': {
    code: 'CIP',
    endpoint: 'insert',
    gloss: 'la acción de utilizar un repuesto con nuestros clientes siendo un trabajo correctivo desde bodegas o facturas',
    originStowageId: 'BM 22',
    destinationStowageId: '',
    reasonId: 'VENTA',
    requiresCentralization: true
  },
  'CIPY': {
    code: 'CIPY',
    endpoint: 'insert',
    gloss: 'la acción de utilizar un repuesto con nuestros clientes siendo un trabajo correctivo desde bodegas o facturas',
    originStowageId: 'BM 22',
    destinationStowageId: '',
    reasonId: 'VENTA',
    requiresCentralization: true
  },
  'CIR': {
    code: 'CIR',
    endpoint: 'insert',
    gloss: 'la acción de utilizar un repuesto con nuestros clientes siendo un trabajo correctivo desde bodegas o facturas',
    originStowageId: 'BM 22',
    destinationStowageId: '',
    reasonId: 'VENTA',
    requiresCentralization: true
  },
  'CIS': {
    code: 'CIS',
    endpoint: 'insert',
    gloss: 'la acción de utilizar un repuesto con nuestros clientes siendo un trabajo correctivo desde bodegas o facturas',
    originStowageId: 'BM 22',
    destinationStowageId: '',
    reasonId: 'VENTA',
    requiresCentralization: true
  },
  'CISG': {
    code: 'CISG',
    endpoint: 'insert',
    gloss: 'la acción de utilizar un repuesto con nuestros clientes siendo un trabajo correctivo desde bodegas o facturas',
    originStowageId: 'BM 22',
    destinationStowageId: '',
    reasonId: 'VENTA',
    requiresCentralization: true
  },
  'EEPP': {
    code: 'EEPP',
    endpoint: 'insert',
    gloss: 'la acción de utilizar un repuesto con nuestros clientes siendo un trabajo correctivo desde bodegas o facturas',
    originStowageId: 'BM 22',
    destinationStowageId: '',
    reasonId: 'ENTRADA',
    providerId: '02.820.851-0',
    requiresCentralization: true
  },
  'MM': {
    code: 'MM',
    endpoint: 'insert',
    gloss: '',
    originStowageId: 'BM 22',
    destinationStowageId: '',
    reasonId: 'ENTRADA',
    requiresCentralization: true
  },
  'PE': {
    code: 'PE',
    endpoint: 'insert',
    gloss: '',
    originStowageId: '',
    destinationStowageId: 'BM 22',
    reasonId: 'ENTRADA',
    providerId: '02.820.851-0',
    requiresCentralization: true
  },
  'TRASP': {
    code: 'TRASP',
    endpoint: 'insertSkipCentralization',
    gloss: '',
    originStowageId: 'BM 22',
    destinationStowageId: 'BM 23',
    reasonId: 'TRASPASO',
    providerId: '02.820.851-0',
    requiresCentralization: false
  }
};

/**
 * Obtener la configuración de un tipo de movimiento
 */
export function getMovementTypeConfig(code: string): MovementTypeConfig | null {
  return DFONTANA_MOVEMENT_TYPES[code] || null;
}

/**
 * Validar si un tipo de movimiento es válido y soportado
 */
export function isValidMovementType(code: string): boolean {
  const config = DFONTANA_MOVEMENT_TYPES[code];
  return config !== undefined && config.endpoint !== null;
}

/**
 * Construir el payload completo para Dfontana según el tipo de movimiento
 */
export function buildDfontanaPayload(
  movementTypeCode: string,
  details: any[],
  solicitudId: number,
  clientEmail?: string
): any {
  const config = getMovementTypeConfig(movementTypeCode);

  if (!config || !config.endpoint) {
    throw new Error(`Tipo de movimiento "${movementTypeCode}" no válido o no soportado`);
  }

  const total = details.reduce((sum, item) => sum + (item.count * item.price), 0);
  const fiscalYear = new Date().getFullYear().toString();
  const date = new Date().toISOString().split('T')[0]; // Format: YYYY-MM-DD

  // Estructura base del payload
  const payload: any = {
    folio: 0,
    documentTypeId: config.code,
    fiscalYear: fiscalYear,
    clientId: clientEmail || '',
    providerId: config.providerId || '',
    gloss: config.gloss || `Descuento stock solicitud #${solicitudId}`,
    originStowageId: config.originStowageId || '',
    destinationStowageId: config.destinationStowageId || '',
    reasonId: config.reasonId || '',
    total: total,
    analysis: {
      againstEBusinessCenter: config.requiresCentralization ? 'GMSADMAYF000000' : '',
      againstEFile: '',
      againstEFileFieldName: '',
      businessCenter: config.requiresCentralization ? 'GMSADMAYF000000' : '',
      clasifier1: '',
      clasifier2: '',
      file: '',
      fileFieldName: ''
    },
    referenceDocumentFolio: 0,
    referenceDocumentType: '',
    date: date,
    externalDocumentID: `SOL-${solicitudId}`,
    details: details.map(item => ({
      articleId: item.articleId,
      description: item.description || '',
      count: item.count,
      coinId: 'PESO',
      comment: item.comment || '',
      price: item.price,
      tipoCentDet: '',
      serialPrefix: '',
      serialSufix: '',
      serialStart: '',
      serials: [],
      lotes: [],
      analysis: {
        againstEBusinessCenter: config.requiresCentralization ? 'GMSADMAYF000000' : '',
        againstEFile: '',
        againstEFileFieldName: '',
        businessCenter: config.requiresCentralization ? 'GMSADMAYF000000' : '',
        clasifier1: '',
        clasifier2: '',
        file: '',
        fileFieldName: ''
      }
    }))
  };

  return payload;
}
